import React,{useEffect} from 'react'
import { Link } from 'react-router-dom'
import Header from'../Component/Header'
import Footer from'../Component/Footer' 
const CovidResponse = () => {
     useEffect(() => {
        document.title = 'Covid Response -  St Peters convent School Faridabad Haryana';  
    }, []); 
  return (
    <>
    <Header/>
    <div className="innerslide">
    <ul className="breadcrumb">
     <li><Link to="/"> Home</Link> </li> 
        <li> Gallery </li> 
     <li>Covid Response </li>
 </ul>
</div>
<div className="innersec">
<div className="container">
     <div className="row">
           <div className="col-lg-12">
              <h1>Covid Response  </h1>
         </div>
     </div>
     <div className="row">
       <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 videosearch">
            <div className="video-gallery">
            <iframe width="100%" height="200" src="https://www.youtube.com/embed/8uFEK9aKJYo?si=UPcELX1RmCn7U8aM" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                 
                    <div> 
                        <h3>Awareness video on Covid </h3> 
                    </div> 
                 
            </div>
        </div>
        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 videosearch">
            <div className="video-gallery">
            <iframe width="100%" height="200" src="https://www.youtube.com/embed/M3KiW-vp4o4?si=KyLH2AA032Ym3q7a" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
               
                    <div> 
                        <h3>Online Exam </h3> 
                    </div> 
                 
            </div>
        </div>
     </div>
  </div>
</div>
<Footer/>
    </>
  )
}

export default CovidResponse
